import { DatabaseTableName } from '@dolfin/business/custom_types'

export const CHALLENGE_BADGE_CATALOG_QUERY_KEY = 'challenge-badge-catalog'
export const CHALLENGE_BADGE_TARGETS_QUERY_KEY = 'challenge-badge-targets'

export const QueryKeys: Record<DatabaseTableName, Record<string, string>> = {
  ai_usage_caps: {},
  ai_usage_events: {},
  activities: {
    get: 'GET_ACTIVITIES'
  },
  activities_audit_log: {},
  compensation_tier_snapshots: {},
  domain_event_deliveries: {},
  domain_events: {},
  flipper_slack_events: {},
  flipper_slack_threads: {},
  flipper_slack_session_delegations: {},
  agent_workflow_runs: {},
  challenge_results: {
    get: 'GET_CHALLENGE_RESULTS'
  },
  badges: {
    get: 'GET_BADGES'
  },
  payout_discrepancies: {
    get: 'GET_PAYOUT_DISCREPANCIES'
  },
  flipper_interactions: {
    get: 'GET_FLIPPER_INTERACTIONS'
  },
  challenges: {
    get: 'GET_CHALLENGES'
  },
  clawbacks: {
    get: 'GET_CLAWBACKS'
  },
  comments: {},
  comments_mentions: {},
  companies: {},
  business_units: {
    get: 'GET_BUSINESS_UNITS'
  },
  business_unit_cost_centers: {
    get: 'GET_BUSINESS_UNIT_COST_CENTERS'
  },
  compensation_letters: {
    get: 'GET_COMPENSATION_LETTERS'
  },
  compensation_calculation_snapshots: {},
  data_issue_processing_runs: {},
  data_issue_processing_streams: {},
  deal_line_items: {
    get: 'GET_DEAL_LINE_ITEMS'
  },
  deal_line_items_audit_log: {},
  exchange_config: {
    get: 'GET_EXCHANGE_CONFIG'
  },
  payout_installments: {
    get: 'GET_COMPENSATION_PAYOUTS'
  },
  compensation_rule_drafts: {
    get: 'GET_COMPENSATION_RULE_DRAFTS'
  },
  compensation_rule_draft_history: {
    get: 'GET_COMPENSATION_RULE_DRAFT_HISTORY'
  },
  compensation_rule_authoring_sessions: {},
  compensation_rule_comments: {},
  csv_preupload_data: {
    get: 'GET_CSV_PREUPLOAD_DATA'
  },
  csv_removed_values: {
    get: 'GET_CSV_REMOVED_VALUES'
  },
  compensation_rule_version_metrics: {
    get: 'GET_COMPENSATION_RULE_VERSION_METRICS'
  },
  compensation_rule_version_metric_setup_dependencies: {},
  compensation_rule_version_editors: {
    get: 'GET_COMPENSATION_RULE_VERSION_EDITORS'
  },
  compensation_rule_version_targets: {
    get: 'GET_COMPENSATION_RULE_VERSION_TARGETS'
  },
  compensation_rule_versions: {
    get: 'GET_COMPENSATION_RULE_VERSIONS'
  },
  compensation_rules: {
    get: 'GET_COMPENSATION_RULES'
  },
  credit_setups: {
    get: 'GET_CREDIT_SETUPS'
  },
  credit_setup_rules: {
    get: 'GET_CREDIT_SETUP_RULES',
    usage: 'GET_CREDIT_SETUP_RULE_USAGE',
    recalculation: 'GET_CREDIT_SETUP_RULE_RECALCULATION'
  },
  credit_setup_rule_assignments: {
    get: 'GET_CREDIT_SETUP_RULE_ASSIGNMENTS'
  },
  credit_setup_rule_metric_values: {},
  credit_setup_consumer_selection_audit: {},
  customers: {},
  csv_mappers: {},
  custom_fields: {
    get: 'GET_CUSTOM_FIELDS'
  },
  custom_field_values: {
    get: 'GET_CUSTOM_FIELD_VALUES'
  },
  custom_record_tables: {
    get: 'GET_CUSTOM_RECORD_TABLES'
  },
  custom_record_tables_teams: {
    get: 'GET_CUSTOM_RECORD_TABLES_TEAMS'
  },
  custom_records: {
    get: 'GET_CUSTOM_RECORDS'
  },
  custom_records_audit_log: {
    get: 'GET_CUSTOM_RECORDS_AUDIT_LOG'
  },
  custom_data_checks: {
    get: 'GET_CUSTOM_DATA_CHECKS'
  },
  data_issues: {},
  data_views: {
    get: 'GET_DATA_VIEWS'
  },
  data_issues_deals: {
    get: 'GET_DATA_ISSUES_DEALS'
  },
  data_issues_invoices: {
    get: 'GET_DATA_ISSUES_INVOICES'
  },
  data_sources: {},
  deal_stages: {
    get: 'GET_DEAL_STAGES'
  },
  deals: {
    get: 'GET_DEALS'
  },
  deals_audit_log: {},
  departments: {
    get: 'GET_DEPARTMENTS'
  },
  exchanges: {
    get: 'GET_EXCHANGES'
  },
  fixed_exchange_rates: {
    get: 'GET_FIXED_EXCHANGE_RATES'
  },
  'email-leads': {},
  executions: {},
  impersonation_logs: {},
  invitations: {
    get: 'GET_INVITATIONS',
    insert: 'INSERT_INVITATION',
    update: 'UPDATE_INVITATION'
  },
  legal_entities: {
    get: 'GET_LEGAL_ENTITIES'
  },
  invoices: {
    get: 'GET_INVOICES'
  },
  invoices_audit_log: {},
  issues: {
    get: 'GET_ISSUES',
    insert: 'INSERT_ISSUES',
    update: 'UPDATE_ISSUES'
  },
  issues_tags: {},
  issued_badges: {
    get: 'GET_ISSUED_BADGES'
  },
  kpis: {
    get: 'GET_KPIS'
  },
  kpis_audit_log: {},
  kpis_tables: {
    get: 'GET_KPIS_TABLES'
  },
  kpis_tables_teams: {
    get: 'GET_KPIS_TABLES_TEAMS'
  },
  line_items: {
    get: 'GET_LINE_ITEMS'
  },
  line_items_audit_log: {},
  locations: {
    get: 'GET_LOCATIONS'
  },
  metric_value_currencies: {
    get: 'GET_METRIC_VALUE_CURRENCIES'
  },
  metric_value_currency_backfills: {
    get: 'GET_METRIC_VALUE_CURRENCY_BACKFILLS'
  },
  metric_values: {
    get: 'GET_METRIC_VALUES'
  },
  metrics: {
    get: 'GET_METRICS'
  },
  metrics_audit_log: {
    get: 'GET_METRICS_AUDIT_LOG'
  },
  notifications: {
    get: 'GET_NOTIFICATIONS'
  },
  notifications_status: {},
  organization_mrr_settings: {},
  organizations: {
    get: 'GET_ORGANIZATIONS'
  },
  organizations_profiles: {
    get: 'GET_ORGANIZATION_PROFILES'
  },
  organizations_profiles_data: {
    get: 'GET_ORGANIZATION_PROFILES_DATA'
  },
  payout_adjustments: {
    get: 'GET_PAYOUT_ADJUSTMENTS'
  },
  payout_categories: {
    get: 'GET_PAYOUT_CATEGORIES'
  },
  payout_validations: {
    get: 'GET_PAYOUT_VALIDATIONS'
  },
  payouts: {
    get: 'GET_PAYOUTS'
  },
  payouts_audit_log: {},
  period_rules_affected_scope: {
    get: 'GET_PERIOD_RULES_AFFECTED_SCOPE'
  },
  period_rules_run_watermarks: {},
  plans: {
    get: 'GET_PLANS'
  },
  plans_drafts: {},
  products: {},
  profile_org_start_date: {
    get: 'GET_PROFILE_ORG_START_DATE'
  },
  profile_org_variable_salary: {
    get: 'GET_PROFILE_ORG_VARIABLE_SALARY'
  },
  profile_status_events: {
    get: 'GET_PROFILE_STATUS_EVENTS'
  },
  profiles: {
    get: 'GET_PROFILES'
  },
  provider_profile_info: {
    get: 'GET_PROVIDER_PROFILE_INFO'
  },
  records_to_be_processed: {
    get: 'GET_RECORDS_TO_BE_PROCESSED'
  },
  records_to_be_processed_history: {
    get: 'GET_RECORDS_TO_BE_PROCESSED_HISTORY'
  },
  rewards: {
    get: 'GET_REWARDS'
  },
  superadmins: {},
  statement_approvals: {
    get: 'GET_STATEMENTS_APPROVALS'
  },
  statement_configs: {
    get: 'GET_STATEMENTS_CONFIGS'
  },
  statements: {
    get: 'GET_STATEMENTS'
  },
  statements_audit_log: {},
  subscriptions: {},
  simulation_run_results: {
    get: 'GET_SIMULATION_RUN_RESULTS'
  },
  simulation_run_traces: {
    get: 'GET_SIMULATION_RUN_TRACES'
  },
  simulation_runs: {
    get: 'GET_SIMULATION_RUNS'
  },
  table_config: {
    get: 'GET_TABLE_CONFIG'
  },
  tags: {
    get: 'GET_TAGS'
  },
  target_achievement: {},
  target_period_amount: {},
  target_profile_amount: {},
  target_team_amount: {},
  targets: {
    get: 'GET_TARGETS',
    user: 'GET_USER_TARGETS'
  },
  teams: {
    get: 'GET_TEAMS'
  },
  teams_challenges: {
    get: 'GET_TEAMS_CHALLENGES'
  },
  teams_plans: {
    get: 'GET_TEAMS_PLANS'
  },
  teams_plans_history: {},
  teams_profiles: {
    get: 'GET_TEAMS_PROFILES'
  },
  teams_profiles_events: {
    get: 'GET_TEAMS_PROFILES_EVENTS'
  },
  teams_statement_configs: {
    get: 'GET_TEAMS_STATEMENT_CONFIGS'
  },
  teams_tags: {
    get: 'GET_TEAMS_TAGS'
  },
  teams_targets: {
    get: 'GET_TEAMS_TARGETS'
  },
  template: {
    get: 'GET_TEMPLATES',
    insert: 'INSERT_TEMPLATE',
    update: 'UPDATE_TEMPLATE'
  },
  template_tags: {},
  tvp_allocation: {
    get: 'GET_TVP_ALLOCATION'
  },
  chat_conversations: {},
  chat_embeddings: {},
  chat_messages: {},
  validation_steps: {
    get: 'GET_VALIDATION_STEPS'
  },
  whistles: {
    get: 'GET_WHISTLES'
  }
}
